import { render, staticRenderFns } from "./PersonaMainView.vue?vue&type=template&id=64c64f62&scoped=true"
import script from "./PersonaMainView.vue?vue&type=script&lang=js"
export * from "./PersonaMainView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c64f62",
  null
  
)

export default component.exports